module.exports = __webpack_public_path__ + "img/responsiveCrestTxt.da05ed56.svg";